import { render, staticRenderFns } from "./ReferralListing.vue?vue&type=template&id=20fd8580&scoped=true&"
import script from "./ReferralListing.vue?vue&type=script&lang=ts&"
export * from "./ReferralListing.vue?vue&type=script&lang=ts&"
import style0 from "./ReferralListing.vue?vue&type=style&index=0&id=20fd8580&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fd8580",
  null
  
)

export default component.exports